import './sass/main.scss';
import './js/index.js';



// WEBPACK FOOTER //
// ./httpdocs/grandclassics/themes/wppt/assets/src/app.js